export default {
  feedbackAudioIndex: '反馈音频 {val1}',
  openAudio: '打开音频',
  history: '用户反馈历史记录',
  theImageCannotExceed: '图片不能超过 {val1}MB 请重新上传!',
  thereAreTypesOfImagesAvailable: '图片类型有误,请上传正确格式的图片!',
  richTextPureText: '富文本/纯文本切换开关',
  richTextContent: '富文本内容（加粗格式、图片等）',
  discard: '丢弃',
  cutFromRichText: '由富文本切换至纯文本将',
  beCareful: '注意：',
  numberOfRichTexts: '对富文本数据结构进行解析。',
  forTheNumberOfUses:
    '对于使用数据接口拉取 faq 数据的可使用纯文本编辑器，否则需要自行',
  switchToPureText: '切换成纯文本模式保存后将丢弃富文本信息（图片等）',
  reply: '回复：',
  articleNbsp: '条 ：',
  feedback: '反馈',
  replyDetails: '回复详情',
  nbspAnti: ' 反馈',
  batchReplyAs: '批量回复成功，共回复 ',
  batchSending: '批量发送(',
  failInSend: '发送失败',
  replyPlan: '回复方案：',
  open: '展开',
  batchSelection: '批量选择的反馈',
  replyToRecommendedStudents: '回复推荐生成回复方案',
  pleaseInTheLeftColumn: '请在左侧列表中选择反馈和',
  thereAreCurrentlyNoPlansAvailable: '暂无方案数据',
  replyAdded: '已添加回复方案（',
  addToReply: '添加到回复(',
  addedBack: '已添加到回复',
  adopt: '采纳',
  intelligentReplyPush: '智能回复推荐',
  automaticFilteringHasBeenImplemented: '自动过滤已回复',
  batchSelected: '批量已选',
  aiRecommendationBack: 'AI推荐回复',
  onlySelectable: '仅可选择已有权限的项目，若无项目信息请联系管理员添加权限',
  pleaseSelectProject: '请选择项目',
  changeOfProjectOwnership:
    '项目归属变更后，反馈信息中的智能分类、用户反馈、反馈来源信息将被置空。',
  batchChangeOffice: '批量变更所属应用',
  networkAbnormalityPlease: '网络异常, 请稍后再试',
  operationSuccessful: '操作成功',
  pleaseSelectProject2: '请选择项目!',
  theImageCannotExceed2: '图片不能超过 {val1}MB 请重新上传!',
  pleaseSelectTheOriginalFirst: '请先选择原反馈来源',
  firstLevelClassification: '一级分类',
  pleaseChooseTheOriginalAndReverse: '请选择原反馈来源',
  originalFeedbackSource: '原反馈来源',
  supportFromExistingSources:
    '支持从现有的反馈来源中选择一级分类,\n                  将复制选择的一级分类下面的所有数据到目标来源。',
  pleaseSelectThePurpose: '请选择目的反馈来源',
  objectiveFeedback: '目的反馈来源',
  processingInProgress: '处理中',
  supportFromExistingSources2:
    '支持从现有的反馈来源中选择一级分类, 将复制选择的一级分类下面的所有数据到目标来源',
  successCopy: '拷贝成功',
  sourceFeedbackSource: '源反馈来源和目的反馈来源不能相同',
  pleaseSelectTheSource: '请选择来源id',
  enterMultipleValues: '输入多个值使用逗号隔开',
  pleaseChooseCustom: '请选择自定义字段',
  editorAndProcessor: '编辑处理人',
  pleaseEnterTi: '请输入 {val1}!',
  more: '更多',
  pleaseEnterSearch: '请输入搜索内容(按enter以搜索)',
  uploadingInProgress: '上传中...',
  theImageCannotExceed3: '图片不能超过 {val1}MB 请重新上传!',
  returnToOtherQuestions: '返回其他问题',
  sendOut: '发送',
  pleaseEnterATitle: '请输入标题搜索',
  addTheFaq: '把FAQ的内容回复给用户',
  setAnalysisDimension: '设置分析维度成功',
  setAnalysisDimension2: '设置分析维度',
  stopGenerating: '停止生成',
  noHelp: '无帮助',
  toBeHelpfulTo: '有帮助',
  evaluatedHelpless: '已评价 无帮助',
  reviewedAsHelpful: '已评价 有帮助',
  copy: '复制',
  regenerate: '重新生成',
  terminationSuccessful: '终止成功',
  requestError: '请求错误:',
  helpingMeWrite: '正在帮我写...',
  aiGenerated: 'AI生成的内容仅供参考，您可以根据实际需要进行修正',
  abandoned: '弃用',
  quote: '引用',
  successfullyGenerated: '生成成功',
  connectionInterruption: '连接中断',
  chooseTheRequiredSystem: '选择需要系统为您生成的分析：',
  currentlyNotGenerated: '暂无已生成日志分析',
  stopAnalyzing: '停止分析',
  outlierExtraction: '异常点提炼',
  summarizeTheTimeline: '总结时序',
  logAnalysisConclusion: '分析结果',
  analyzeProgress: '处理进程',
  pleaseEnterAsk: '输入你的问题并回车触发提问',
  logChatAskTips:
    '您可以基于日志文件向模型提问任何问题, 例如: 请根据反馈内容, 输出跟其相关的日志',
  logFile: '日志文件',
  analyzingLogFile: '解析日志文件中, 请耐心等待...',
  pleaseInputKeyWords: '请输入关键词进行搜索',
  pleaseSelectFirst: '非全局搜索, 需要先选择一个文件',
  confirm: '确认',
  time: '时间',
  loadingInProgress: '加载中',
  logAnalysisCompleted: '----  日志分析完成',
  logAnalysisAccuracy: '----  日志分析准备中, 请等待',
  logAnalyzeTabForAnalysis: '分析',
  logAnalyzeTabAnalysis: '日志分析',
  logAnalyzeTabForAsk: '提问',
  logAnalyzeTabHistory: '分析历史',
  problemAnalysisSmall: '分析小结',
  aggus: '{val1}人',
  aggco: '{val1}条',
  relatedFeedbackSummary: '关联如下{val1}条反馈',
  feedbackTitlesOmitted: '另有 {val1} 条反馈未展示标题',
  value: '{val1} 反馈人数占比: {val2} ',
  value2: '{val1} 反馈人数: {val2} ',
  value3: '{val1} 反馈量占比: {val2} ',
  feedbackQuantityAg: '反馈量: {val1} ',
  unknownState: '未知状态',
  waitingForReply: '待回复',
  setUpAListExhibition: '设置列表展示字段与排序',
  nothing: '无',
  sourceLink: '来源链接:',
  feedbackClassificationN: '反馈分类: ',
  feedbackUserLetter: '反馈用户信息',
  state: '状态',
  totalTota: '共 {val1} 条',
  creationTime: '创建时间',
  oncal: 'Oncall单',
  transferred: '已转',
  transferredToOnc: '已转Oncall单',
  transferredToTap: '已转TAPD',
  stay: '待',
  already: '已',
  unrecognized: '未识别',
  toBeFollowedUpOn: '待跟进',
  unknown: '未知',
  viewAll: '查看全部',
  recentlyUsersHaveBeenAgainst: '最近用户反馈(',
  pleaseEnterFloatingPoint: '请输入浮点型数字',
  pleaseEnterPlasticSurgery: '请输入整形数字',
  theNumberOfWordsInTheRemarksIsNot: '备注字数不得超过_400_个字符',
  changeFailed: '更改失败',
  changeSuccessful: '更改成功',
  processingPersonnel: '处理人',
  errorInType: '类型错误',
  jumpLink: '跳转链接',
  pleaseEnterTheField: '请输入字段名称搜索',
  addFilter: '添加筛选',
  advanceFilter: '高级筛选',
  exportOption: '导出选项',
  pleaseChooseWhetherOrNot: '请选择是否为空',
  pleaseEnter: '请输入',
  forEmpty: '为空',
  notEmpty: '不为空',
  contain: '包含',
  equals: '等于',
  selectedFieldsTo: '已选字段以及排序 （',
  noFieldsAvailableAtTheMoment: '暂无字段',
  searchFields: '搜索字段',
  exportFieldSelection: '导出字段选择 (最多可导出 10万 条)',
  exportAsWecomDocument: '导出为企微文档',
  advancedQuery: '高级查询',
  exportSuccessful: '导出成功!',
  exportWecomSuccessful: '导出成功！请查看企微【AiSee机器人】推送。',
  exportFailedPlease: '导出失败,请稍后再试',
  weAreGuidingYou: '正在为您导出,请耐心等待...',
  feedbackDetails: '反馈详情',
  imageContent: '图片内容',
  picturesLinking: '图片链接',
  pleaseChoose: '请选择',
  setListDisplay: '设置列表显示字段',
  aField: '个字段',
  nbHasBeenSelected: '已选择:  ',
  usedForAnalyzingACertain:
    '用于分析某类参数(含自定义字段)的数值分布或环比变化，生效后可在【反馈参数统计】中查看',
  userAccount: '用户账号',
  noRelevantIntelligenceAvailableAtTheMoment: '暂无相关智能分类!',
  searchIntelligenceScore: '搜索智能分类',
  selectedCategoryT: '已选分类: {val1}',
  feedbackClassification: '反馈分类',
  processingStatus: '处理状态',
  feedbackInfo: '反馈内容',
  pleaseEnterTheType: '请输入分类名称搜索',
  pleaseChooseIntelligent: '请选择智能分类',
  userSelectedScore: '用户自选分类',
  pleaseChooseACategory: '请选择分类',
  pleaseEnterTheField2: '请输入字段值',
  multipleUsagePoints: '多个使用,分隔',
  pleaseChooseARating: '请选择打分选项',
  pleaseSelectAQuestionnaire: '请选择问卷',
  allCategories: '所有分类',
  versionFeedbackVolume: '版本反馈量',
  value4: '{val1} 人',
  value5: '{val1} 条',
  feedbackTypeN: '反馈类型: {val1}<br/> 反馈量: {val2}<br/> 占比: {val3}',
  feedbackTypeN2: '反馈类型: {val1}<br/> 占比: {val2}%',
  feedbackQuantity: '反馈数量',
  statisticalDimension: '统计维度:',
  monthly: '按月',
  byWeek: '按周',
  onADailyBasis: '按日',
  statisticalMethod: '统计方式:',
  notSelectedAtAll: '全不选',
  selectAll: '全选',
  value6: '{value}人',
  value7: '{value}条',
  fileT: '{val1}趋势统计.xlsx',
  intelligentClassificationTrend: '智能分类趋势.xlsx',
  exportExc: '导出Excel',
  close: '关闭',
  dataView: '数据视图',
  intelligentClassificationTrend2: '反馈分类趋势图',
  viewTrends: '查看趋势',
  trend: '趋势',
  numberOfFeedbackUsers: '反馈用户数环比',
  feedbackFromThePreviousCycle: '上周期反馈用户数',
  feedbackOnUserProportion: '反馈用户占比',
  numberOfFeedbackUsers2: '反馈用户数',
  feedbackOnAMonthOnMonthBasis: '反馈数环比',
  feedbackFromThePreviousCycle2: '上周期反馈数',
  previousWeek: '(上周期)',
  nowWeek: '(本周期)',
  feedbackQuantity2: '反馈数',
  thePicturesAndVideosHaveBeen: '图片/视频已损坏',
  addPicturesAndVideos: '图片视频加载中...',
  imagePreview: '图片预览',
  videoPreview: '视频预览',
  nbspIntelligence: '  智能分类趋势图',
  pleaseInputAnImage: '请输入图片链接',
  multilingual: '多语言',
  optionLabelName: '（选项/标签）名称',
  pleaseClickOnMultilingual: '请点击多语言按钮输入名称',
  modifyOptionLabel:
    '修改（选项/标签）会影响所有使用该（选项/标签）的问卷, 请谨慎操作',
  modifiedSuccessfully: '修改成功',
  pleaseEnterAName: '请输入名称或者图片链接',
  typel: '{val1}名称',
  pleaseEnterAName2: '请输入名称',
  serverException: '服务器异常, 请稍后再试',
  title: '{val1} - 多语言',
  spanish: '西班牙语',
  portuguese: '葡萄牙语',
  arabic: '阿拉伯语',
  korean: '韩语',
  japanese: '日语',
  malayLanguage: '马来语',
  hindiLanguage: '印地语',
  indonesia: '印度尼西亚语',
  vietnamese: '越南语',
  thai: '泰语',
  traditionalChinese: '繁体中文',
  pleaseEnterSimplifiedChinese: '请输入简体中文',
  simplifiedChinese: '简体中文',
  pleaseEnterEnglish: '请输入英文内容',
  englishFallback: '英文(兜底)',
  uploadLogsSeparately: '上传日志分析',
  journal: '日志',
  recordingFrequency: '录频',
  experimentalData: '实验数据',
  switch: '开关',
  sdkLogs: 'SDK日志',
  chooseJapaneseChronicle: '选择日志文件',
  pleaseSelectALog: '// 请选择日志文件',
  selectTime: '选择时间',
  selectDate: '选择日期',
  onlyLeavesCanBeSelected: '只能选择叶子节点',
  feedbackClassificationSelection: '反馈分类选择',
  pleaseEnterToReply: '请输入要回复的内容（按Enter发送, Ctrl+Enter换行）',
  messageRecallNotice: '消息发出后7日内可撤回(仅限管理员与本人操作)',
  viewDetails: '查看详情 >',
  comingSoon: '敬请期待',
  feedbackFailed: '反馈失败',
  feedbackSuccessful: '反馈成功',
  resultsOfEnforcement: '执行结果',
  tipsLimit: 'tips: 限制每秒触发插件的反馈数,最大每秒触发500条反馈',
  frequencyLimit: '限频',
  pleaseSelectAPlugin: '请选择插件',
  implement: '执行',
  batchTriggerInsertion: '批量触发插件',
  pluginExecutionLost: '插件执行失败: {val1}',
  see: '查看',
  open2: '打开',
  transferredToOnc2: '已转Oncall',
  addToQuestion: '添加至问题',
  feedbackFollowUpOperation: '反馈跟进操作成功',
  enterEnterpriseMicro: '输入企业微信英文名,用;分隔',
  pleaseCheckAr: '请检查{val1}的名字是否正确',
  currentlySelected: '当前选择的产品为:',
  pleaseSelectAProduct: '请选择产品',
  project: '项目',
  pleaseEnterTheProduct: '请输入产品关键字',
  invalidIssue: '误报',
  confirmedIssue: '已确认问题',
  notConfirmed: '未确认',
  pleaseChooseToModify: '请选择修改状态',
  pleaseInputProcessing: '请输入处理人',
  noteMultipleTreatments: '注: 多个处理人以英文分号隔开',
  pleaseInputProcessing2: '请输入处理人!',
  pleaseEnterTheQuestion: '请输入问题描述',
  describe: '描述',
  pleaseEnterADescription: '请输入描述!',
  pleaseEnterTheQuestion2: '请输入问题标题',
  pleaseEnterATitle2: '请输入标题!',
  editingIssues: '编辑问题',
  modifyTheProblemToBeLost: '修改问题失败, 请稍后再试',
  modifyTheProblemTo: '修改问题成功',
  multipleProcessors: '多个处理人以英文分号;隔开',
  synchronizeUpdates: '同步更新',
  questionTitle: '问题标题',
  problemLevel: '问题等级',
  addToExisting: '添加至已有问题',
  addToTAPD: '添加至已有TAPD',
  newProblem: '新问题',
  articleFeedback: '条反馈',
  articleFeedbackData: '条数据',
  selected: '已选择',
  afterAddressingTheIssueItCanBeResolved:
    '转问题后可在【问题跟进】中查看，也可在添加后进行转单操作',
  pleaseClarifyTheMeaningOfTheSentence:
    '请将语意一致的反馈设置为问题后跟进，可在【问题跟进】中查看。',
  thisProjectDoesNotHave: '该项目没有绑定Tapd!',
  followUpOnTransferringIssues: '转问题跟进',
  followUpOnTransferringIssuesTips: '可以进一步批量转为tapd、oncall处理',
  bindTap: '绑定tapd成功',
  bindTap2: '绑定tapd失败: err: {val1}',
  relatedIssuesLost: '关联问题失败',
  relatedIssuesBecome: '关联问题成功',
  relatedIssuesLost2: "'关联问题失败, 请稍后再试:'{val1}",
  issueBindSuccessButTapdBindFailed: '问题关联成功，但绑定 TAPD 失败',
  issueBindSuccessButTapdBindFailedWithError: '问题关联成功，但绑定 TAPD 失败: {val1}',
  issueCreatedButTapdBindFailed: '问题已创建，但绑定 TAPD 失败: {val1}',
  issueBindSuccessButNoTapdInfo: '关联问题成功,但未找到已有tapd信息',
  createIssueAndBindTapdSuccess: '创建问题并绑定 TAPD 成功',
  createIssueFailed: '创建问题失败',
  createIssueFailedWithError: '创建问题失败: {val1}',
  operationFailed: '操作失败: {val1}',
  addToIssueAndBindTapd: '添加至问题并绑定tapd',
  pleaseEnterTapdId: '请输入 TAPD ID',
  pleaseSelectIssue: '请选择问题',
  foundRelatedIssue: '已找到关联问题~',
  selectIssue: '选择问题',
  pleaseSelectIssueToBind: '请选择要关联的问题',
  noRelatedIssueFoundWillCreateNew: '未找到相关问题，将创建新问题',
  pleaseSelectWorkspace: '请选择工作空间',
  dataContentSyncUpdate: '数据内容同步更新',
  moreFields: '更多字段',
  getWorkspaceListFailed: '获取 workspace 列表失败',
  addAsProblem: '添加为问题',
  addAsProblemAndCopy: '添加为问题并复制',
  transferProblemAndCopy: '转问题并复制',
  addAndConvertToO: '添加并转Oncall',
  addAndConvertToT: '添加并转TAPD',
  theTitleCannotBe: '标题不能为空',
  theHandlerCannot: '处理人不能为空',
  withdrawalMessageLost: '撤回消息失败,请刷新页面后再尝试!',
  withdrawTheMessage: '撤回消息成功!',
  replySuccessful: '回复成功',
  turn: '转',
  batchManualReturn: '批量手动回复',
  reply2: '快捷回复',
  pleaseSelectAtLeast: '请选择至少一条记录',
  userInitiated: '已发起用户评分，等待用户响应',
  thisServices: '人工服务满意度',
  unknownUser: '未知用户',
  withdraw: '撤回',
  continue: '继续',
  whetherToWithdrawI: '是否撤回:【{val1}】, 撤回后用户将不可见该回复',
  withdrawMessage: '撤回消息',
  confirmThisFeedback: '确认该反馈已处理完毕,并向用户发起评分?',
  initiateSatisfaction: '发起满意度评分',
  alreadyInitiated: '已经发起过评分了,请查看用户的评分结果!',
  userInitiated2: '已发起用户评分，等待用户响应!',
  quickReply: '快速回复',
  originalFeedbackReply: '原反馈回复详情',
  noViewOriginal: '暂无查看原反馈详情的权限',
  aiSee: 'AiSee助手为您推荐如下回复方案:',
  uploadFailedPlease: '上传失败, 请稍后再试',
  uploadImage: '上传图片',
  pleaseEnterAReply: '请输入回复内容或者上传图片',
  pictureUploadingInProgress: '图片上传中...',
  pleaseEnterCo: '请输入{val1}，多个使用逗号或空格分割',
  pleaseSelectProcessing: '请选择处理状态',
  multipleOnCs:
    '多个oncall指派人通过分号";"分隔, 优先派单给此处填写的指派人(未填则派单给 oncall 平台配置的值班人员)',
  oncal2: 'oncall指派人',
  configurationMethod: '配置方法',
  pleasePrepareInAdvanceInO: '请提前在oncall平台配置对应规则, 否则建单不成功。',
  oncal3: 'oncall业务分类',
  oncal4: 'oncall运营产品',
  newOnc: '新建ONCALL单',
  oncal5: 'oncall转单失败,请重新输入',
  noOperationalAuthority: '没有操作权限,请申请权限后再操作.',
  oncal6: 'oncall转单失败,请重新转单',
  oncal7: 'oncall转单成功',
  sReco: '{val1}等一条反馈',
  pleaseChooseOn: '请选择oncall运营产品',
  proposal: '建议',
  tips: '提示',
  commonly: '一般',
  serious: '严重',
  deadly: '致命',
  empty: '--空--',
  beOfNoGreatImportance: '无关紧要',
  low: '低',
  in: '中',
  high: '高',
  urgent: '紧急',
  newToTa: '新建转Tapd',
  addComments: '追加评论',
  pleaseChooseOne: '请选择一个处理人',
  configureOtherT: '配置其他tapd项目',
  convertToTapd: '转 Tapd 发生异常,请到 Tapd 空间中查看转单结果!',
  convertToTapd2: '转 Tapd 需求单成功!',
  convertToTapd3: '转 Tapd 缺陷单成功!',
  demand: '需求',
  waitingForTheFeed: '等{val1}条反馈',
  pleaseSelectProcessing2: '请选择处理人',
  pleaseChooseATitle: '请选择标题',
  pleaseSelectType: '请选择类型',
  pleaseSelectNew: '请选择新建到的Tapd空间',
  viewDetails2: '查看详情',
  managementBackendCheck: '>>> 管理后台查看问题详情: ',
  divst:
    '<div style="display: flex">终端日志: <div style="display: inline-block">{val1}</div></div>',
  ahref: '<a href="{val1}" style="cursor: pointer;">日志信息{val2}</a><br/>',
  isItRoo: '是否Root: 否',
  isItRoo2: '是否Root: 是',
  networkFee: '网络: {val1} <br/><br/>',
  modelFee: '型号: {val1} <br/><br/>',
  manufacturerFee: '厂商: {val1} <br/><br/>',
  systemVersionF: '系统版本: {val1} <br/><br/>',
  regionalFee: '地域: {val1} <br/><br/>',
  feedbackTimeF: '反馈时间: {val1}<br/><br/>',
  discoveredVersionF: '发现版本: {val1}<br/><br/>',
  accountFee: '账号: {val1}<br/><br/>',
  defect: '缺陷',
  pleaseEnterTa: '请输入TAPD链接中的长ID',
  pleaseEnterTa2: '请输入TAPD链接中的长ID!',
  defectId: '缺陷ID',
  requirementId: '需求ID',
  pleaseSelectType2: '请选择类型!',
  type: '类型',
  relatedTo: '关联到',
  convertToTapd4: '转 Tapd 发生异常,请重试或联系管理员处理!',
  convertToTapd5: '转 Tapd 问题单成功!',
  waitingForTheFeed2: '等{val1}条反馈',
  associateTap: '关联Tapd单',
  pleaseEnterMa: '请输入{val1}!',
  waitingForTheFeed3: '等{val1}条反馈',
  timeIsTheMost: '[{val1} 最新汇总共 {total_count_to_replace} 个反馈]',
  divst2:
    '<div style="display: flex">后台日志: <div style="display: inline-block">{val1}</div></div><br/>',
  divst3:
    '<div style="display: flex">终端日志: <div style="display: inline-block">{val1}</div></div>',
  ahref2: '<a href="{val1}" style="cursor: pointer;">日志信息{val2}</a><br/>',
  imgal2:
    '<img alt="图片.jpg" style="width: 180px; margin: 5px 10px 0 0" src="{val1}">',
  networkFee2: '网络: {val1} <br/><br/>',
  modelFee2: '型号: {val1} <br/><br/>',
  manufacturerFee2: '厂商: {val1} <br/><br/>',
  systemVersionF2: '系统版本: {val1} <br/><br/>',
  regionalFee2: '地域: {val1} <br/><br/>',
  feedbackTimeF2: '反馈时间: {val1}<br/><br/>',
  discoveredVersionF2: '发现版本: {val1}<br/><br/>',
  accountFee2: '账号: {val1}<br/><br/>',
  fixedUnfolding: '固定展开',
  automaticContraction: '自动收缩',
  navigationDisplay: '导航显示方式',
  chinese: '中文',
  switchLanguage: '切换语言',
  productPermissionApplication: '【产品权限申请】消息提醒设置',
  messageReceptionConfiguration: '消息接收配置',
  updateFailed: '更新失败!',
  updateSuccessful: '更新成功!',
  enterpriseWeChat: '企微邮件',
  logOutAndLogIn: '退出登录',
  messageConfiguration: '消息配置',
  permissionReview: '权限审批',
  feedbackOnOpinions: '意见反馈',
  copyId: '复制ID',
  second: '次',
  feedbackInThePastThreeDays: '近三天反馈',
  inThePastYearThe: '近一年第',
  currentFeedback: '当前反馈',
  goToTheFeedbackList: '去反馈列表查看',
  accumulatedInThePastYear: '近一年累计反馈{val1}次',
  accumulatedReversalsThisMonth: '本月累计反馈 ',
  forTheFirstFeedback: '首次反馈用户',
  theLastTimeOn: '最近一次于',
  copyUserAccount: '复制用户账号',
  accordingToTheCurrentTime: '按当前时间向前推移',
  whole: '全部',
  allFeedbackVersion: '全部反馈版本',
  edition: '版本',
  allSources: '全部来源',
  allFeedbackCategories: '全部反馈类型',
  switchList: '切换',
  rankingList: '榜单',
  htmlSource: 'HTML 源码模式',
  visualizationMode: '可视化模式',
  pleaseEnterTheApplication: '请输入申请原因',
  reasonForApplication: '申请原因:',
  pleaseSelectOnTheLeftSide: '请在左侧选择需要申请权限的产品',
  selectedApplication: "已选择应用",
  batchApplyRole: '批量设置角色',
  firstLevelApplicationName: '一级应用名称',
  pleaseSelectAnApp: '请选择应用',
  afterApplicationManagementIsRequired:
    '申请后，需管理员审批后可访问对应的应用。',
  applyingToJoinShould: '申请加入应用',
  thirdLevelProductName: '三级产品名称',
  secondaryProductName: '二级产品名称',
  applicationFailed: '申请失败: ',
  applicationSuccessful: '申请成功',
  pleaseChooseToApply: '请选择申请权限的角色',
  pleaseFillInTheApplicationForm: '请填写申请原因',
  pleaseChooseToApply2: '请选择申请权限的产品',
  aiSee2: 'AISee小助手',
  conversionTypeProduct: '转正式产品',
  viewProductConnection: '查看产品接入指南',
  ifYouHaveAnyQuestionsPlease: '若有疑问请联系AiSee小助手',
  inAutomaticClassification: '自动分类中',
  enterTheExperience: '进入体验',
  automaticallyCreated: '已自动创建',
  importedHistory: '已导入历史数据将执行自动分类，仅适用于试用产品',
  addAfterActivation: '启用后新增的反馈将通过大模型进行自动分类',
  areYouSureToEnableIt: '您确定启用模型:',
  step4Report: '步骤四：报告生成',
  step3Results: '步骤三：结果验证',
  step2Model: '步骤二：模型训练',
  step1Data: '步骤一：数据准备',
  convertToFormalProduction: '转为正式产品',
  ohMyGodYouCanCommunicate:
    '天，您可以通过样例感受真实的洞察分析效果，若需要接入AiSee请转为正式产品。',
  remainingExperiencePeriod: '体验期剩余',
  inDoubt: '有疑问?',
  recommendedExperience: '推荐体验以下核心功能',
  trialGuide: '试用向导',
  intelligentMonitoringSystem:
    '智能监测：系统实时追踪反馈数据波动，支持「自定义条件+阈值预警」组合配置，自动推送企微预警通知，精准定位高频突发问题',
  viewExamples: '查看示例',
  setAlarmRules: '设置告警规则',
  intelligentClassificationRoot:
    '智能分类：根据业务反馈数据实现自动分类，支持人工校准优化，动态趋势看板实时呈现',
  intelligentClassification: '智能分类',
  viewOrModify: '查看或修改反馈分类',
  setClassificationTree: '设置分类树',
  preciseSubscriptionPre:
    '精准订阅：预设「分类标签+关键词+多人推送」多维条件组合，即时触发企业微信消息推送',
  selectScenarioOne: '选择场景一键订阅',
  globalClosedLoopEmbedding:
    '全域闭环：嵌入AiSee帮助与反馈中心通用H5，实现「咨询-查询-提交-跟进」全流程覆盖',
  feedbackPageHConnected: '反馈页H5接入应用',
  fillInFeedbackAndSubmit: '填写反馈提交',
  userClassificationConfiguration: '用户分类配置',
  faqSettings: 'FAQ设置',
  smartReply: '智能回复',
  aiReplyPush: 'AI回复推荐引用',
  pollingClassificationStatus: '轮询分类状态失败:',
  checkModelStorage: '检查模型存在时出错:',
  modelGenerationSuper: '模型生成超时',
  updateStepsLost: '更新步骤失败，请联系小助手',
  iSee: '我知道了',
  activateImmediately: '立即启用',
  basedOnImports:
    '基于导入的反馈数据，AiSee已为您自动生成专属的分类树，\n          启用后新增的反馈将执行自动分类',
  feedbackClassificationTree: '反馈分类树创建完成',
  automaticClassificationAndExtraction: '自动分类提示',
  visitAiS:
    '访问AiSee指定的公共体验demo空间，使用AiSee提供的样例数据体验核心功能',
  experiencePublicD: '体验公共 Demo',
  aiSee3:
    'AiSee为您自动创建一个体验类的专属产品，您可以导入≤500条数据查看真实的功能效果',
  experienceExclusiveProducts: '体验专属产品',
  each: '每',
  relationship: '关联关系',
  faqReply: 'FAQ回复',
  updateTime: '更新时间:',
  creator: '创建人:',
  prompt: '提示词:',
  mcpse: 'mcp server链接',
  ordinaryApi: '普通API',
  toolType: '工具类型:',
  toolLink: '工具链接:',
  confirmDeletion: '确认删除',
  confirmDeletion2: '确定要删除智能体"{val1}"吗？删除后无法恢复。',
  agent: '智能体',
  whenCallingALink: '调用链接时需要传递的header，{"key": "value"}形式',
  toolHea: '工具Header',
  toolLinkH: '工具链接header格式不正确，请输入有效的JSON格式',
  ordinaryApi2: '1. 普通API, 2. mcp server链接',
  toolLinkClass: '工具链接类型',
  useToolchain: '使用工具链接时，工具链接类型不能为空',
  youCanSpecifyOne: '可以指定一个链接，普通的API或者mcp server链接',
  toolLink2: '工具链接',
  toolConfiguration: '工具配置',
  doYouWantIntelligence: '你希望智能体如何分析问题',
  promp: 'prompt不能为空',
  theNameOfTheIntelligentAgent: '智能体的名称',
  intelligentAgentName: '智能体名称',
  intelligentAgentName2: '智能体名称不能为空',
  saving: '保存中...',
  save: '保存',
  addIntelligentAgent: '添加智能体',
  editIntelligentAgent: '编辑智能体',
  pleaseChooseFirst: '请先选择应用',
  updateFailed2: '更新失败',
  inEditingMode: '编辑模式下缺少智能体信息',
  thereAreCurrentlyNoIntelligentAgentsAvailable: '暂无智能体, 你可以添加一个',
  noMatchFound: '没有找到匹配的智能体',
  searching: '查询中...',
  configurationGuidelines: '配置指引',
  pleaseInputIntelligence: '请输入智能体名称',
  customizedAnalyticsIntelligence: '定制分析智能体',
  deleteIntelligentAgent: '删除智能体失败:',
  deleteFailedMissing: '删除失败：缺少必要参数',
  obtainIntelligentAgents: '获取智能体列表失败:',
  expandTheFullText: '展开全文',
  oneClickAnalysis: '一键分析',
  hidden: '已隐藏',
  pleaseClickTheButton: '请点击按钮上传日志文件',
  fileUploadLost: '文件上传失败',
  pleaseSelectAScene: '请选择场景',
  editScene: '编辑场景',
  youCanDefine:
    '您可以定义一些具体场景，设置对应的特征词，AiSee会重点筛选提升效率并增强结论的可读性',
  referenceSceneClassification: '引用场景分析',
  analyzeLogStorage: '分析日志存在异常，请联系小助手',
  thereAreDifferencesInTheProcess: '过程存在异常，请联系小助手',
  taskCreationLost: '创建任务失败',
  noSelectionMade:
    '未选择任何文件! 如想分析所有文件, 请用"全局搜索"过滤后，再进行分析',
  enterTheQuestionBack: '输入问题，回车/点击发送',
  analysisErrorM: '分析出错:{val1}',
  analysisCompleted: '分析完成',
  noSelected: '未选中任何文件, 将分析所有文件',
  feedbackTimeD: '反馈时间: {val1}',
  feedbackContentD: '反馈内容: {val1}',
  rDLead: '研发负责人',
  fixedVersion: '修复版本',
  discoveryVersion: '发现版本',
  problemDescription: '问题描述',
  explanationOfDefinition: '释义说明',
  featureWords: '特征词',
  pleaseEnterRD: '请输入研发负责人',
  pleaseEnterRepair: '请输入修复版本',
  pleaseEnterTheDiscovery: '请输入发现版本',
  pleaseEnterChinese: '请输入中文释义',
  pleaseEnterTheFeatures: '请输入特征词',
  setFeatureWords: '设置特征词',
  pleaseEnterTheScene: '请输入场景名称',
  youCanDefine2:
    '您可以定义一些具体场景，如登录异常检测等，并设置对应的特征词，以便在分析过程中重点筛选这些信息，AiSee也根据对应的释义输出结论，让分析结果的可读性更好',
  addLogSection: '添加日志分析场景',
  editLogSection: '编辑日志分析场景',
  error: '错误',
  theSceneNameHasBeenChanged: '场景名称已存在',
  logAnalysisField: '日志分析场景',
  thereAreCurrentlyNoScenesAvailable: '暂无场景数据',
  noMatchFound2: '没有找到匹配的场景',
  addScene: '添加场景',
  afterOpeningItWillStartFrom:
    '开启后将从所有文件中搜索,返回过滤后的内容,注意全局搜索时会忽略时间过滤条件',
  globalSearch: '全局搜索',
  inputToExclude: '输入要排除的关键词，点击回车提交',
  defaultUseIsPositive: '默认使用正则表达式搜索',
  excludeKeywords: '排除关键词',
  usageScenarioConfiguration: '使用场景配置中的关键词进行搜索',
  selectScene: '选择场景',
  enterToSearch: '输入要搜索的关键词，点击回车提交',
  supportTheUseOfPositive:
    '支持使用正则表达式，使用正则表达式搜索时，需要使用/内容/包裹，如/ab+c/',
  searchKeywords: '搜索关键词',
  globalSearchMeeting: '全局搜索, 会搜索所有文件, 并忽略时间过滤条件, 请知悉',
  globalSearchPlease: '全局搜索请指定搜索关键词或排除关键词',
  smallBeforeAndAfterFeedback: '反馈前后1小时',
  feedbackBeforeAndAfter: '反馈前后30分钟',
  feedbackBeforeAndAfter2: '反馈前后10分钟',
  hoursBeforeFeedback: '反馈前1小时至反馈时间',
  minutesBeforeFeedback: '反馈前30分钟至反馈时间',
  minutesBeforeFeedback2: '反馈前10分钟至反馈时间',
  viewBestPractice: '查看最佳实践案例效果',
  problemSolvingPleaseDont:
    '问题排查别焦虑，DeepSeek为您解谜题！点击「一键分析」，即刻获取建议指引',
  notYetFull: '尚未得到满意的结果？您可以进一步分析～',
  viewTheCompleteContent: '查看完整内容',
  inTheCurrentSummary: '(当前小结内容过长，已为您折叠展示)',
  thoughtProcess: '思考过程',
  pushTime: '推送时间',
  pleaseEnterAMessage: '请输入消息标题',
  messageTitle: '消息标题',
  projectName: '项目名称',
  pleaseEnterTheGroupMachine: '请输入群机器人的webhook地址',
  pushToGroup: '推送到群',
  pleaseSelectNotification: '请选择通知组',
  referenceNotificationGroup: '引用通知组',
  manuallyAdd: '手动添加',
  pleaseChooseToReceive: '请选择接收方式',
  pushToIndividuals: '推送给个人',
  subscriptionMethod: '订阅方式',
  subscriptionNameConvenience: '订阅名称便于在订阅列表中查询',
  subscriptionName: '订阅名称',
  multiPersonSubscription: '多人订阅',
  allRankings: '所有榜单',
  pushRankings: '推送榜单',
  enterpriseWeChat2: '企微消息的末尾展示备注内容',
  subscriptionSuccessfullyReceived:
    '订阅成功,收到新的反馈后，会在五分钟内推送到企业微信',
  inTheSameScene: '同一场景下, 可添加多个条件(如不同分类)分别触发推送消息',
  addPushFrequency: '添加推送频次',
  classifyTheSystem: '将分类的统计结果进行推送',
  intelligentClassification2: '智能分类分析小结订阅推送',
  expandSubClass: '展开子分类',
  expandSubClassTip: '开启后显示所选分类子分类',
  subscribe: '订阅',
  advancedSettings: '高级设置',
  useOfFiltering: '将筛选的用户反馈，定时进行推送',
  selectedUserFeedback: '精选用户反馈定时推送',
  addNewQuestions: '将新增的问题单以推送提醒您(处理人包含您本人)',
  newQuestionPush: '新增问题推送',
  putUnderYourName: '将您名下的问题单处理情况定时推送给您',
  problemFollower: '问题跟进人处理定时推送本人',
  thereWillBeComplianceWithTheRegulations: '将有符合条件的新增用户反馈推送',
  addUserReverse: '新增用户反馈推送',
  selectedAtACertainTime: '精选一定时间周期内的TOP用户声音',
  userVoiceSubscription: '用户声音订阅推送',
  userVoicePush: '用户声音推送',
  sessionClassification: '会话分类',
  withinTheAiSession: 'AI会话内容',
  upvoteDownvote: '赞/踩',
  customerReviews: '用户评价',
  satisfactionScore: '满意度评分',
  unfinished: '未结束',
  ended: '已结束',
  hasItEnded: '是否已结束',
  replyStatus: 'AI处理状态',
  conversationType: '会话类型',
  conversationUserMessage: '会话用户信息',
  whenSubmittingAConversation: '会话提交时间',
  aiConversationStatus: 'AI会话状态',
  recor: '{val1}分',
  feedbackProcessingRecord: '反馈处理记录',
  notTheCurrentProduct: '非当前产品的反馈暂不支持跳转',
  onlineAnalysis: '在线分析',
  doYouWantToContinueGuiding: '是否继续导出？',
  theArticleMayLeadTo: '条，可能会导出较长时间，建议分段导出。',
  currentExportQuantity: '当前导出数据量较大',
  continueExporting: '继续导出',
  exportConfirmation: '导出确认',
  conversationContent: '会话内容',
  userVoiceMaster: '用户声音主题',
  tapdChain: 'TAPD链接',
  doYouWantToHideTheOperation: '是否隐藏操作栏',
  pleaseSelectAtLeast2: '请选择至少一个人员！',
  searchForUserLost: '搜索用户失败:',
  customField: '自定义字段趋势图',
  tdsty: '<td style="padding: 0 10px; width: 180px">反馈名称</td>',
  ifTheVideoIsNot: '如果视频不能正常播放, 请点击上方下载视频按钮本地播放。',
  downloadVideo: '下载视频',
  downloadFailedPlease: '下载失败，请联系aisee小助手，错误信息：{val1}',
  pleaseInputTheFile: '请输入文件名称',
  fileName: '文件名称',
  viewHistoricalDocuments: '查看历史文件',
  conductAnalysis: '进行分析',
  uploadLocalText: '上传本地文件',
  theAnalysisResultsAreNotAccurate: '分析结果不满意？{val1}',
  fileLoadingInProgress: '文件加载中...',
  uploader: '上传者',
  uploadTime: '上传时间',
  correspondingUploaded: '对应上传的原始文件，压缩包或单日志文件',
  onlineViewingDay: '在线查看日志',
  viewLogsAnd: '查看日志及智能分析',
  openLogDetails: '打开日志详情失败,请稍后重试',
  uploadFileLost: '上传文件失败:',
  fileUploadLost2: '文件上传失败，未获取到URL或者fid为空',
  openLogDetails2: '打开日志详情失败:',
  retrieveLogU: '获取日志URL失败,请稍后重试',
  retrieveLogU2: '获取日志URL失败',
  endTime: '结束时间',
  startTime: '开始时间',
  pleaseSelectALanguage: '请选择语言',
  cannotExceedL: '不能超过{val1}种语言',
  canAddLAgain: '可再添加 {val1} 种其他语言',
  alreadySetE: '已经设置 {val1} 种其他语言',
  english: '英语',
  traditionalChineseChannel: '繁体中文（台湾）',
  simplifiedChinese2: '简体中文（中国大陆）',
  jumpToFollowUp: '跳转跟进',
  submit: '提交',
  conversionTypeProduct2: '转正式产品将保留历史记录（如反馈分类、FAQ等）',
  clickToUploadImage: '点击上传图片',
  imageResolution: '（图片分辨率120 * 120）',
  productImage: '产品图片',
  pleaseEnterTheProduct2: '请输入产品描述',
  productDescription: '产品描述',
  productDescriptionIsNotProvided: '产品描述不能超过150个字符',
  pleaseEnterTheProduct3: '请输入产品名称',
  productName: '产品名称',
  productNameOnly: '产品名称只能包含中文、字母、数字、下划线、空格和短横线',
  theProductNameIsNot: '产品名称不能超过20个字符',
  goToObs: '去OBS中查看',
  belongingOperationalProduct:
    '所属运营产品',
  contactAiS1: '搜索不到对应产品，可以联系',
  AiSeeAssistant: 'aisee小助手',
  contactAiS2: '添加',
  pleaseChooseInO: '请选择在OBS系统中，您所在业务对应的运营产品',
  pleaseSelectYourAffiliation: '请选择所属运营产品',
  unableToFindProduct: '无法找到产品，请联系管理员',
  theImageSizeIsIncorrect: '图片大小不能超过 5MB!',
  onlyJCanBeUploaded: '只能上传 JPG/PNG 格式的图片!',
  problemClassification: '问题分类',
  followerRole: '跟进者角色',
  questionType: '问题类型',
  pleaseEnterTa3: '请输入TAPD查询',
  pleaseEnterYourQuestion: '请输入问题标题查询',
  aiHasHelpedYou: 'AI已为您找到推荐问题~',
  tapdPrecision: 'TAPD精准查询',
  questionTitleCheck: '问题标题查询',
  filterMethod: '筛选方式',
  clickToUseA: '点击使用AI智能生成问题标题～',
  generating: '正在生成中...',
  aiHasHelpedYou2: 'AI已为您生成标题，点击可再次生成～',
  userFeedbackQuestion: '用户反馈问题跟进：{val1}{val2}',
  invalidFeedback: '无效反馈',
  theProductIsNotUserFriendly: '产品不好用',
  usersDoNotKnowHowToUse: '用户不会用',
  functionNotAvailable: '功能不可用',
  safetyRisk: '安全风险',
  abnormalSituation: '异常情况',
  normalAnswer: '正常回答',
  manualIntervention: '人工介入',
  problemNotMatching: '问题未匹配',
  tooManyRounds: '轮数过多',
  intentionNotRecognized: '意图未识别',
  leisureDialogue: '闲聊状态',
  customIntent: '自定义意图',
  theAboveIsAi: '以上为AI客服会话消息',
  satisfaction: '智能客服满意度',
  aiSessionCancellation: 'AI会话消息数',
  askAssistant: '去培训Agent',
  optimizeThisRound: '优化此轮',
  theUserIsAlreadyInC: '用户已在C端删除该反馈',
  replyFailedM: '回复失败: {val1}',
  batchReplyPositive: '批量回复正在处理中, 请等待完成后再试。',
  sentSatisfactory: '已发送满意度评分',
  card: '】卡片',
  usersFeelThatThereIs: '用户觉得有帮助',
  usersFeelThatThereIsNothing: '用户觉得无帮助',
  quickReply2: '快捷回复',
  statementSuccessfullyCompleted: '结单成功',
  clickToEndThis: '点击结束本次咨询服务',
  replyAfterTheEnd: '结束后回复状态将更新为“人工服务已结束”',
  confirmedIssue2: '确定问题已解决，结束会话？',
  svgConversion: 'SVG 转换失败',
  ifThereIsNoOnc: '若无oncall运营产品，',
  synchronizeAfterModification: '修改后, 同步更新问题标题',
  tipsT3:
    '\n    {val1}<a href="{val2}" target="_blank" style="cursor: pointer;">{val3}</a><br/><br/>\n    【问题描述】<br/>\n    <div style="padding-left: 20px;">\n      {val4}<br/>\n    </div>\n  ',
  divst4:
    '<div style="display: flex">终端日志: <div style="display: inline-block">{val1}</div></div>',
  ahref3: '<a href="{val1}" style="cursor: pointer;">日志信息{val2}</a><br/>',
  imgal:
    '<img alt="图片.jpg" style="width: 180px; margin: 5px 10px 0 0" src="{val1}">',
  feedbackFromBr:
    '<br/>\n    【反馈内容】<br/>\n    <div style="padding-left: 20px;">\n      {val1}\n      {val2}\n      {val3}\n      {val4}\n      {val5}\n      {val6}\n      {val7}\n    </div><br/>\n    【反馈截图】<br/>\n    <div style="padding-left: 20px;">\n      {val8}<br/><br/>\n    </div><br/>\n    【反馈视频】<br/>\n    <div style="padding-left: 20px;">\n      {val9}<br/><br/>\n    </div><br/>\n    【日志信息】<br/>\n    <div style="padding-left: 20px;">\n      {val10}\n    </div><br/>\n    【机型相关】<br/>\n    <div style="padding-left: 20px;">\n      {val11}\n      {val12}\n      {val13}\n      {val14}\n      {val15}\n    </div><br/>\n    【补充信息】<br/>\n    <div style="padding-left: 20px;">\n      {val16}\n    </div><br/>\n  ',
  imgal3:
    '<img alt="图片.jpg" style="width: 180px; margin: 5px 10px 0 0" src="{val1}">',
  tipsT10:
    '{val1}[<a href="{val2}" target="_blank" style="cursor: pointer;">{val3}</a>]<br/><br/>\n    【反馈内容】<br/>\n    <div style="padding-left: 20px;">\n      {val4}\n      {val5}\n      {val6}\n      {val7}\n      {val8}\n      {val9}\n      {val10}\n    </div><br/>\n    【反馈截图】<br/>\n    <div style="padding-left: 20px;">\n      {val11}<br/><br/>\n    </div><br/>\n    【反馈视频】<br/>\n    <div style="padding-left: 20px;">\n      {val12}<br/><br/>\n    </div><br/>\n    【日志信息】<br/>\n    <div style="padding-left: 20px;">\n      {val13}\n      {val14}\n    </div><br/>\n    【机型相关】<br/>\n    <div style="padding-left: 20px;">\n      {val15}\n      {val16}\n      {val17}\n      {val18}\n      {val19}\n    </div><br/>\n    【补充信息】<br/>\n    <div style="padding-left: 20px;">\n      {val20}\n    </div><br/>\n  ',
  applicationVersionFrom: '应用版本自定义筛选',
  pleaseEnterTheVersion: '请输入版本编号',
  versionSearch: '版本搜索',
  selectedVersion: '已选版本（',
  pleaseEnterFilter: '请输入筛选条件后检索',
  thereAreCurrentlyNoFilterNumbersAvailable: '暂无筛选数据',
  filter: '筛选',
  versionFilteringRange: '版本筛选范围',
  basicSettings: '基础设置',
  enterpriseWeChatRobot: '企业微信机器人',
  enterpriseWeChatAccount: '企微英文帐号',
  deleteConditionGroup: '删除条件组',
  addCondition: '添加条件',
  addConditionGroup: '添加条件组',
  addSiblingCondition: '添加同级条件',
  deleteThisCondition: '删除此条件',
  pleaseSelectField: '请选择字段',
  pleaseSelectRelation: '请选择关系',
  pleaseEnterValue: '请输入值',
  pleaseSelectTime: '请选择时间',
  loadingEllipsis: '加载中…',
};
